import { useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { AcceptCreatorInviteResponse } from '@bvengineering/cas-member-gateway-service-client';
import { useApiMutation } from '@/api/hooks/useMutation';
import { campaignKeys } from '@/api/queryKeys';

export function useAcceptCreatorInvite() {
  const queryClient = useQueryClient();

  return useApiMutation<AcceptCreatorInviteResponse, AxiosError, string>({
    mutationFn: (api) => async (inviteToken: string) => {
      const response = await api.campaigns.campaignsControllerAcceptCreatorInvite({ inviteToken });
      return response.data;
    },
    onSuccess: (_data, inviteToken) => {
      queryClient.invalidateQueries({ queryKey: campaignKeys.invite(inviteToken) });
      queryClient.invalidateQueries({ queryKey: campaignKeys.lists() });
    },
  });
}
